import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  form: {
    templateId: null,
    tanks: [],
    batchId: null,
    startDate: null,
    priority: null,
    cellarmenIds: [],
  },
  steps: [],
  stepConfigs: {},
};

export const protocolApplicationDraftSlice = createSlice({
  name: "protocolApplicationDraft",
  initialState: initialState,
  reducers: {
    setDraftForm: (state, action) => {
      state.form = { ...state.form, ...action.payload };
    },
    setDraftSteps: (state, action) => {
      state.steps = action.payload;
    },
    setStepConfig: (state, action) => {
      const { idx, config } = action.payload;
      state.stepConfigs[idx] = config;
    },
    clearDraft: (state) => {
      return initialState;
    },
  },
});

export const { setDraftForm, setDraftSteps, setStepConfig, clearDraft } =
  protocolApplicationDraftSlice.actions;

export default protocolApplicationDraftSlice.reducer;
